import _ from 'lodash';

import { handleErrors } from './ErrorActions';
import * as savedSearchesApi from '../api/saved-searches';
import { EXCEL_FILE_EXTENSION } from '../constants/SavedSearches';
import { invokeBlobFileDownloading } from '../utils/commonUtils';
import { getContentDispositionFile } from '../utils/savedSearchUtils';

export const GET_SAVED_SEARCH_EXPORT_PENDING = 'GET_SAVED_SEARCH_EXPORT_PENDING';

export const getSavedSearchExportPending = ({ key, isPending }) => ({
  type: GET_SAVED_SEARCH_EXPORT_PENDING,
  payload: {
    key,
    isPending,
  },
});

export const getSavedSearchExport = (savedSearch) => async (dispatch) => {
  const { entityName, translatedSearchName, searchName } = savedSearch;
  try {
    dispatch(getSavedSearchExportPending({ key: searchName || entityName, isPending: true }));

    const { data: apiData, headers } = await savedSearchesApi.getSavedSearchExport(savedSearch);

    if (apiData instanceof Blob && headers['content-type'] === 'application/json') {
      const text = await apiData.text();
      const json = JSON.parse(text);

      if (json.hasError) {
        dispatch(handleErrors(json.errors));
      }
    } else {
      const contentDisposition = headers['content-disposition'];
      const contentDispositionFile = getContentDispositionFile(contentDisposition);

      const defaultFileName = translatedSearchName || searchName || contentDispositionFile?.name;
      const filename = _.get(savedSearch, ['metadata', 'exportFileName'], defaultFileName);
      const fileExtension = contentDispositionFile?.extension || EXCEL_FILE_EXTENSION;

      invokeBlobFileDownloading(apiData, `${filename}.${fileExtension}`);
    }
    dispatch(getSavedSearchExportPending({ key: searchName || entityName, isPending: false }));
  } catch (error) {
    dispatch(handleErrors(error));
    dispatch(getSavedSearchExportPending({ key: searchName || entityName, isPending: false }));
  }
};
